import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Folder, FileText, Download, ArrowRight } from 'lucide-react';
import './InfoPage.css';

const InfoPage = () => {
  return (
    <div className="info-page">
      <div className="page-container">
        {/* Header */}
        <header className="page-header">
          <Link to="/" className="back-button">
            <span>Back to Home</span>
          </Link>
          <h1 className="page-title">How to Use COVA</h1>
          <p className="page-subtitle">System Usage Instructions</p>
        </header>

        {/* Content */}
        <div className="info-content">
          <div className="intro-section">
            <h2>Navigation Overview</h2>
            <p>
              COVA provides a simple, organized way to access your Computer Science 
              learning materials. Follow the step-by-step navigation below to find 
              and download your study resources.
            </p>
          </div>

          <div className="navigation-steps">
            <div className="step">
              <div className="step-icon">
                <Home size={32} />
              </div>
              <div className="step-content">
                <h3>1. Start at Home</h3>
                <p>
                  Begin by selecting your semester from the home page. 
                  Choose between Semester 1 or Semester 2 based on your current studies.
                </p>
              </div>
            </div>

            <div className="step">
              <div className="step-icon">
                <Folder size={32} />
              </div>
              <div className="step-content">
                <h3>2. Choose Your Unit</h3>
                <p>
                  Browse through available units for your selected semester. 
                  Each unit represents a specific course or subject area.
                </p>
              </div>
            </div>

            <div className="step">
              <div className="step-icon">
                <FileText size={32} />
              </div>
              <div className="step-content">
                <h3>3. Select Category</h3>
                <p>
                  Choose between "Notes" for lecture materials and study guides, 
                  or "Past Papers" for examination materials and practice tests.
                </p>
              </div>
            </div>

            <div className="step">
              <div className="step-icon">
                <Download size={32} />
              </div>
              <div className="step-content">
                <h3>4. Download Files</h3>
                <p>
                  Browse the available PDF files and click the download button 
                  to save them to your device for offline study.
                </p>
              </div>
            </div>
          </div>

          <div className="tips-section">
            <h2>Tips for Best Experience</h2>
            <div className="tips-grid">
              <div className="tip">
                <h4>Organized Learning</h4>
                <p>
                  Follow the structured path: Semester &rarr; Unit &rarr; Category 
                  to maintain an organized study approach.
                </p>
              </div>
              <div className="tip">
                <h4>Regular Downloads</h4>
                <p>
                  Download materials regularly to have offline access, especially 
                  before examinations and important lectures.
                </p>
              </div>
              <div className="tip">
                <h4>File Management</h4>
                <p>
                  Organize downloaded files on your device by unit and category 
                  for easy reference during study sessions.
                </p>
              </div>
            </div>
          </div>

          <div className="help-section">
            <h2>Need Help?</h2>
            <p>
              If you encounter any issues or have questions about the system, 
              reach out for assistance. The system is designed to be intuitive 
              and user-friendly for all Computer Science students.
            </p>
            <div className="help-actions">
              <Link to="/" className="help-button">
                <Home size={16} />
                Return to Home
              </Link>
              <Link to="/about" className="help-button secondary">
                Learn More About COVA
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoPage;
